import { Filter } from "./filter";

export class Newest extends Filter {
  constructor(public top?: number) {
    super("newest");
  }
  public static get DEFAULT() {
    return new Newest(50);
  }
}
